import React from 'react';
import c from 'classnames';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  PARAGRAPH_VIEW_MODE_DEFAULT,
  PARAGRAPH_VIEW_MODE_FULLSCREEN,
  PARAGRAPH_VIEW_MODE_CAMPAIGN_COLOR_THEME,
} from '../../../config/constants';

import './style.scss';

const ParagraphQuote = ({ entity, viewMode = PARAGRAPH_VIEW_MODE_DEFAULT }) => {
  const text = entity.getIn(['field_text', 0, 'processed']);
  const author = entity.getIn(['field_author', 0, 'value']);
  const viewModeIsFullscreen = viewMode === PARAGRAPH_VIEW_MODE_FULLSCREEN;
  const viewModeIsCampaignPageColorTheme = viewMode === PARAGRAPH_VIEW_MODE_CAMPAIGN_COLOR_THEME;

  // TODO - Make "color_variant_one" dynamic by getting the parent theme color variant (ticket in monday).
  const paragraphClassNames = c('ParagraphQuote', 'active-theme-background-color', { 'Fullscreen': viewModeIsFullscreen });
  const innerClassNames = c({ 'Fullscreen__content-centered': viewModeIsFullscreen });
  const colClassNames = c('', {
    'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2': !viewModeIsFullscreen && !viewModeIsCampaignPageColorTheme,
    'col-12 col-lg-10 offset-lg-1 col-xl-12': viewModeIsFullscreen,
    'col-12 col-md-5 offset-md-1': viewModeIsCampaignPageColorTheme,
  });

  return (
    <div className={paragraphClassNames}>
      <div className={innerClassNames}>
        <Container large={viewModeIsFullscreen}>
          <div className="row">
            <div className={colClassNames}>
              <div className="ParagraphQuote__wrapper">
                <div className="ParagraphQuote__text">
                  <WysiwygField
                    property="schema:text"
                    html={text}
                  />
                </div>
                <div className="ParagraphQuote__author small">
                  {author}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default ParagraphQuote;
